import { Box, Container, Grid } from "@mui/material";
import type { ReactNode } from "react";

export interface PageLayoutProps {
  children: ReactNode;
  fullWidth?: boolean;
}

export const PageLayout = (props: PageLayoutProps) => {
  const { children, fullWidth = false } = props;

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: "100vh",
          overflow: "auto",
        }}
      >
        {fullWidth ? (
          <Box sx={{ mt: 13, mb: 4 }}>
            <Box
              sx={{
                margin: "0px 40px 0 40px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {children}
            </Box>
          </Box>
        ) : (
          <Container maxWidth="xl" sx={{ mt: 13, mb: 4 }}>
            <Grid container>{children}</Grid>
          </Container>
        )}
      </Box>
    </Box>
  );
};
